/**
 * Things to fix:
 *  - sticky nav does not resize on tablet/mobile if sticky when window resized - maybe on other conditions too, need testing
 *  - horizontal swipe inertia???
 *  - generally make sure things get re-initialized or whatever is needed on resize
 *  - figure out correct way to set bottomSpacing on sticky initialization and update it on resize
 */
let taxJumperTouchStartX = 0,
    taxJumperTouchEndX = 0

let     taxType = '',
        taxTocID = '',
        taxStickySectionID = '';

const taxJumperSiteNav = document.querySelector('.site-header__navigation-primary');
const taxjumperSiteFooter = document.querySelector('.site-footer');

const taxJumperTermListWrapper = document.querySelector('.tax-index-list');
const taxJumperTermList = document.querySelector('.tax-index-list ul');
const taxJumperPrevBtn = document.querySelector('.tax-index-prev');
const taxJumperNextBtn = document.querySelector('.tax-index-next');

taxJumperPrevBtn.addEventListener("click", taxJumpBtnClick);
taxJumperNextBtn.addEventListener("click", taxJumpBtnClick);

taxJumperTermList.addEventListener('touchstart', function (event) {
    taxJumperTouchStartX = event.changedTouches[0].screenX;
}, false);

taxJumperTermList.addEventListener('touchend', function (event) {

    taxJumperTouchEndX = event.changedTouches[0].screenX;
    taxJumpHandleSwipe();
}, false);


function taxJumpHandleSwipe() {
    if (taxJumperTouchEndX < taxJumperTouchStartX) {
        //console.log('Swiped Left');
        taxJumpScrollHorizontal('right');
    }
    if (taxJumperTouchEndX > taxJumperTouchStartX) {
        //console.log('Swiped Right');
        taxJumpScrollHorizontal('left');
    }
    // if (touchendY === touchstartY) {
    //     console.log('Tap');
    // }
}

function taxJumpBtnClick(e) {
  var targ;
  if (!e) var e = window.event;
  if (e.target) targ = e.target;
  else if (e.srcElement) targ = e.srcElement;
  if (targ.nodeType == 3) // defeat Safari bug
      targ = targ.parentNode;
  if (targ.classList.contains('tax-index-prev')) {
    taxJumpScrollHorizontal('left');
  }
  else {
    taxJumpScrollHorizontal('right');
  }
}

function taxJumpScrollHorizontal(direction) {
    const viewportWidth = taxJumperTermListWrapper.offsetWidth
    const listWidth = taxJumperTermList.offsetWidth
    taxJumperTermListWrapper.classList.remove('fade-right')
    taxJumperTermListWrapper.classList.remove('fade-left')
    if (listWidth > viewportWidth) {
        const oneItem = taxJumperTermList.getElementsByTagName('li')[0]
        let itemWidth = oneItem.offsetWidth
        var style = oneItem.currentStyle || window.getComputedStyle(oneItem)
        itemWidth += parseFloat(style.marginRight)
        const numVisibleItems = Math.floor(viewportWidth / itemWidth)
        const scrollChunk = numVisibleItems * itemWidth
        const currentPos = taxJumpGetTranslateX(taxJumperTermList)
        const maxNegScroll = (listWidth - viewportWidth) * -1
        let newPos = 0

        if (direction == 'right') {
            newPos = currentPos - scrollChunk
            if (newPos < maxNegScroll) {
                newPos = maxNegScroll
            }
        } else {
            newPos = currentPos + scrollChunk
            if (newPos > 0) {
                newPos = 0
            }
        }

        taxJumperTermList.style.transform = 'translateX(' + newPos + 'px)' //transition: transform .5s;   transition: 100ms;
        taxJumperSetFade(newPos)
    }
}

function taxJumperSetFade(position = 0) {
    taxJumperTermListWrapper.classList.remove('fade-right')
    taxJumperTermListWrapper.classList.remove('fade-left')

    const viewportWidth = taxJumperTermListWrapper.offsetWidth
    const listWidth = taxJumperTermList.offsetWidth
    if (position < 0) {
        taxJumperTermListWrapper.classList.add('fade-left')
    }
    if (-position + viewportWidth < listWidth) {
        taxJumperTermListWrapper.classList.add('fade-right')
    }
}

function taxJumpGetTranslateX(element) {
    var style = window.getComputedStyle(element)
    var matrix = new WebKitCSSMatrix(style.transform)
    return matrix.m41
}

function getTaxIndexContentHeight(selector) {
    if (typeof selector == 'undefined') {
        return
    }
    id = seismicUtilities.scrub(selector)
    if (!selector || selector == '') {
        return
    }

    const eMain = document.querySelector(selector)
    if (eMain) {
        //return document.body.scrollHeight - ( eMain.offsetHeight) + 500;
        let calloutHeight = 500
        const callout = document.querySelector('.midline-callout-block')
        if (typeof callout != 'undefined' && callout != null) {
            calloutHeight = callout.offsetHeight + 128
        }
        //console.log ('calloutheight: ' + calloutHeight);
        return taxjumperSiteFooter.getBoundingClientRect().height + calloutHeight
    }
}

function doTaxIndexSticky(type, tocID, stickyID) {
    if (typeof jQuery != 'function' || typeof jQuery.fn.sticky != 'function') {
        return
    }
    const wrapperClasses = 'sticky-wrapper ' + type + '-jumper-toc-sticky-wrapper'
    let topOffset = taxJumperSiteNav.offsetHeight;
    if (type == 'glossary') {
        topOffset -= 1;
    }

    //jQuery('#glossary-index-wrapper').unstick();  /* need a way to reset the sticky nav on a resize... but this isn't working correctly */
    jQuery(tocID).sticky({
        topSpacing: topOffset,
        /* getWidthFrom: tocID, */
        /* responsiveWidth: true, */
        widthFromWrapper: true,
        bottomSpacing: getTaxIndexContentHeight(stickyID),
        wrapperClassName: wrapperClasses,
        zIndex: 10,
    })
}

function taxSectionObserverCallback(elements) {
    taxJumperSetSelectedIndex()
}
const taxSectionObserverOptions = {
    root: null,
    rootMargin: '-150px',
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
}
const taxSectionObserver = new IntersectionObserver(taxSectionObserverCallback, taxSectionObserverOptions)
const taxSections = document.querySelectorAll('.taxonomy-index-block')

function taxJumperSetSelectedIndex() {
    //const contentTop =  taxJumperSiteNav.offsetHeight + taxJumperTermListWrapper.offsetHeight;
    //console.log ('after scroll, checking for first visible section:');
    let selectedTaxListItem = document.querySelector('.tax-index-list ul li.selected')
    if (selectedTaxListItem) {
        selectedTaxListItem.classList.remove('selected')
    }

    let contentTop = taxJumperTermListWrapper.getBoundingClientRect().bottom + 72
    var found = false
    taxSections.forEach(section => {
        if (!found) {
            var sectionViewport = section.getBoundingClientRect()
            //console.log ('section top: ' + sectionViewport.top + 'section bottom: ' + sectionViewport.bottom + ' content top: ' + contentTop);
            if (sectionViewport.bottom > contentTop) {
                var indexID = section.getAttribute('data-taxonomy-index')
                selectedTaxListItem = document.querySelector('.tax-index-list ul li[data-item="' + indexID + '"]')
                selectedTaxListItem.classList.add('selected')
                found = true
            }
        }
    })
}

$(window).smartresize(function () {
    taxJumperScreenChange()
})

let portrait = window.matchMedia('(orientation: portrait)')
portrait.addEventListener('change', function (e) {
    taxJumperScreenChange()
})

function taxJumperScreenChange() {
    const currentPos = taxJumpGetTranslateX(taxJumperTermList)
    const viewportWidth = taxJumperTermListWrapper.offsetWidth
    const listWidth = taxJumperTermList.offsetWidth
    const maxNegScroll = (listWidth - viewportWidth) * -1

    // const eMain = document.querySelector('.glossary-block');
    // const eMainHeight = eMain.getBoundingClientRect.height;
    // console.log('resize body height: ' + document.body.scrollHeight + ', glossary top: ' + eMain.offsetTop + ', glossary height: ' + eMain.offsetHeight);
    jQuery(taxTocID).unstick()
    doTaxIndexSticky(taxType, taxTocID, taxStickySectionID)
    jQuery(taxTocID).sticky('update')

    if (currentPos < 0 && currentPos < maxNegScroll) {
        taxJumpScrollHorizontal('right')
    } else {
        taxJumperSetFade()
    }
}

function taxJumperIndexInit() {
    jumperLinks = document.querySelectorAll('.tax-index-list ul li a')
    jumperLinks.forEach(el =>
        el.addEventListener('click', event => {
            selectedEl = document.querySelector('.tax-index-list ul li.selected')
            if (typeof selectedEl != 'undefined' && selectedEl != null) {
                selectedEl.classList.remove('selected')
            }
            event.target.parentElement.classList.add('selected')
        })
    )

    taxSections.forEach(section => {
        taxSectionObserver.observe(section)
    })
    doTaxIndexSticky(taxType, taxTocID, taxStickySectionID)
    taxJumperSetFade()
}

document.addEventListener(
    'DOMContentLoaded',
    function () {
        haveGlossary = document.querySelector('.glossary-list')
        if (typeof haveGlossary != 'undefined' && haveGlossary != null) {
            taxType = 'glossary'
            taxTocID = '#glossary-index-wrapper'
            taxStickySectionID = '.glossary-block'
        }

        taxJumperIndexInit()
    },
    false
)
